module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["container"]
  }, [(_vm.show) ? _c('dof-overlay', _vm._b({
    attrs: {
      "show": _vm.show && _vm.hasOverlay,
      "opacity": _vm.opacity
    },
    on: {
      "dofOverlayBodyClicked": _vm.dofOverlayBodyClicked
    }
  }, 'dof-overlay', _vm.mergeOverlayCfg, false)) : _vm._e(), (_vm.show) ? _c('div', {
    ref: "dof-mask",
    staticClass: ["dof-mask"],
    style: _vm.maskStyle,
    attrs: {
      "hack": _vm.shouldShow
    }
  }, [_c('div', {
    style: _vm.contentStyle
  }, [_vm._t("default")], 2), (_vm.showClose) ? _c('div', {
    staticClass: ["mask-bottom"],
    style: {
      width: _vm.width + 'px'
    }
  }, [_c('image', {
    staticClass: ["closeIcon"],
    attrs: {
      "placeholder": _vm.localCloseIcon,
      "src": _vm.closeIcon
    },
    on: {
      "click": _vm.cancel
    }
  })]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-b2c3bef6!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-mask/index.vue
// module id = 649
// module chunks = 0 1